import { Action } from '@ngrx/store';
import {
    FILTER_SET,
    FILTER_UNSET,
    LIST_ARRANGE_BY,
    LIST_BULK_UPDATING_SET,
    LIST_COLUMN_IDS_SET,
    LIST_DESELECT,
    LIST_DESELECT_BY_GROUP,
    LIST_FETCHING_MORE_SET,
    LIST_FETCHING_SET,
    LIST_HIGHLIGHT,
    LIST_ITEM_SET,
    LIST_ITEM_UNSET,
    LIST_ITEMS_UNSET_ALL,
    LIST_MERGE,
    LIST_SELECT,
    LIST_SELECT_BY_GROUP,
    LIST_SELECTION_MODE_SET,
    LIST_SET,
    LIST_SORT_BY,
    LIST_SORT_UNSET,
    LIST_UNHIGHLIGHT,
} from '../../action-types';
import { ListColumn } from '../../../models/common/list-column';
import { $log } from '../../../utils/logger';
import { PageMeta } from '@core/models/common/page-meta';
import { ListGroupBy } from '@core/models/common/list-group-by';
import { ListSortBy } from '@core/models/common/list-sort-by';
import { ListSortDirection } from '@core/models/common/list-sort-direction';

/**
 * Updates a list of ids and entities.
 * Uses domain to lookup entitiy in state slice.. entities[domain].
 */
export class ListSetAction implements Action {
    readonly type = LIST_SET;

    constructor(public payload: {
        entities?: any,
        result?: any,
        items: any,
        schema: any,
        meta: PageMeta,
        domain: string
    }) {
    }
}

/**
 * Updates the list fetching status.
 */
export class ListSetFetchingAction implements Action {
    readonly type = LIST_FETCHING_SET;

    constructor(public payload: boolean) {}
}
export class ListSetFetchingMoreAction implements Action {
    readonly type = LIST_FETCHING_MORE_SET;

    constructor(public payload: boolean) {}
}

export class ListSetBulkUpdatingAction implements Action {
    readonly type = LIST_BULK_UPDATING_SET;

    constructor(public payload: {
        isUpdating: boolean
    }) {}
}

/**
 * Updates list item entity.
 */
export class ListItemSetAction implements Action {
    readonly type = LIST_ITEM_SET;

    constructor(public payload: {
        item: any,
        schema: any,
        domain: string
    }) {
    }
}

export class ListItemUnsetAction implements Action {
    readonly type = LIST_ITEM_UNSET;

    constructor(public payload: {
        id: any,
        domain: string
    }) {
    }
}

export class ListItemUnsetAllAction implements Action {
    readonly type = LIST_ITEMS_UNSET_ALL;

    constructor(public payload?: {
        domain: string,
        preserveEntities?: boolean
    }) {}
}

export class ListMergeAction implements Action {
    readonly type = LIST_MERGE;

    constructor(public payload: {
        entities?: any,
        result?: any,
        items: any,
        schema: any,
        meta: PageMeta,
        domain: string
    }) {
    }
}

/**
 * List item selection action.
 * Multiple defaults to true.
 */
export class ListSelectAction implements Action {
    readonly type = LIST_SELECT;

    constructor(public payload: {
        ids: string[],
        domain: string,
        multiple?: boolean
    }) {
    }
}

export class ListDeselectAction implements Action {
    readonly type = LIST_DESELECT;

    constructor(public payload: {
        ids: string[],
        domain: string
    }) {
    }
}

export class ListHighlightAction implements Action {
    readonly type = LIST_HIGHLIGHT;

    constructor(public payload: {
        ids: string[],
        domain: string,
        multiple?: boolean
    }) {
    }
}

export class ListUnhighlightAction implements Action {
    readonly type = LIST_UNHIGHLIGHT;

    constructor(public payload: {
        ids: string[],
        domain: string,
        multiple?: boolean
    }) {
    }
}

export class ListSelectByGroupAction implements Action {
    readonly type = LIST_SELECT_BY_GROUP;

    constructor(public payload: {
        groups: string[],
        groupBy: ListGroupBy,
        domain: string
    }) {
    }
}

export class ListDeselectByGroupAction implements Action {
    readonly type = LIST_DESELECT_BY_GROUP;

    constructor(public payload: {
        groups: string[],
        groupBy: ListGroupBy,
        domain: string
    }) {
    }
}

/**
 * Defines the sorting and grouping of the list state.
 */
export class ListArrangeByAction implements Action {
    readonly type = LIST_ARRANGE_BY;

    constructor(public payload: {
        groups: string[],
        sortBy?: ListSortBy,
        groupBy?: ListGroupBy,
        sortDirection?: ListSortDirection,
        domain: string
    }) {
    }
}

export class ListSortByAction implements Action {
    readonly type = LIST_SORT_BY;

    constructor(public payload: any) {
    }
}

export class FilterUnsetAction implements Action {
    readonly type = FILTER_UNSET;

    constructor(public payload: any) {
    }
}

export class FilterSetAction implements Action {
    readonly type = FILTER_SET;

    constructor(public payload: any) {
    }
}

export class SortUnsetAction implements Action {
    readonly type = LIST_SORT_UNSET;

    constructor(public payload: any) {
    }
}

export class ListSelectionModeSetAction implements Action {
    readonly type = LIST_SELECTION_MODE_SET;

    constructor(public payload: {
        mode: SelectionMode
    }) {}
}

export class ListColumnIdsSetAction implements Action {
    readonly type = LIST_COLUMN_IDS_SET;

    constructor(public payload: {
        columnIds: string[]
    }) {}
}
